import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentVaultMasterComponent } from './document-vault-master.component';
import { Menus } from 'app/shared/constants/menu.constant';
import { AuthGuardService as AuthGuard } from '../../shared/guard/authorization-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'documentVault',
    pathMatch: 'full'
  },
  {
    path: 'documentVault',
    component: DocumentVaultMasterComponent,
    data: { title: 'Document Vault Master',menuName: Menus.DOCUMENT_VAULT},
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentVaultMasterRoutingModule { }
